import Controller from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';
import { waitFor } from '@ember/test-waiters';
import { tracked } from '@glimmer/tracking';

import * as Sentry from '@sentry/ember';
import { dropTask } from 'ember-concurrency';

import { authBaseURL } from 'register-partners-js/constants/hosts';
import { MainLayout } from 'register-partners-js/react/components/layouts/main';

import styles from './styles.module.css';

export default class RegisterOrganizationOwnerPhoneNumberController extends Controller {
  mainLayout = MainLayout;

  @service('intl') intl;
  @service networkManager;
  @service router;
  @service segment;
  @service userManager;

  @tracked error;

  @action
  handleGoBack() {
    this.router.replaceWith('registration.credentials-success');
  }

  get phoneNumber() {
    return this.userManager.currentUser.phoneNumber || this.model.owner.phoneNumber;
  }

  submitTask = dropTask(
    waitFor(async phoneNumber => {
      if (!this.numberIsObscured(phoneNumber)) {
        try {
          let owner = await this.model.owner;

          owner.phoneNumber = phoneNumber;
          await this.updatePhoneNumber(phoneNumber);

          let hasOwnerTaxInfo =
            typeof owner?.get('taxPayerOutsideLegalCountry') === 'boolean' &&
            typeof owner?.get('usTaxPayer') === 'boolean';
          if (hasOwnerTaxInfo) {
            owner.save();
          }

          this.segment.identify({ phone: phoneNumber });

          // v2/users/me/phone_number doesn't return the updated user payload, hence the extra GET call here
          await this.userManager.loadUser();

          if (!phoneNumber) {
            Sentry.captureMessage('Empty phone-number was send to backend', { model: this.model });
          }

          return this.router.transitionTo('registration.nature-of-ops');
        } catch (error) {
          let isPhoneNumberError = error.status === 422 && error.responseJSON?.errors?.phone_number;
          let isNetworkError = error.status || error.status === 0;

          let message = this.intl.t('errors.internal-server-error');

          if (isPhoneNumberError) {
            Sentry.captureMessage('Backend phone validation failed');
            message = this.intl.t('errors.phone-number-invalid');
          } else if (!isNetworkError) {
            Sentry.captureException(error);
          }

          this.error = message;
        }
      } else {
        return this.router.transitionTo('registration.nature-of-ops');
      }
    })
  );

  updatePhoneNumber(phoneNumber) {
    return this.networkManager.request(`${authBaseURL}/v2/users/me/phone_number`, {
      method: 'POST',
      body: JSON.stringify({
        user: {
          phone_number: phoneNumber,
        },
      }),
    });
  }

  numberIsObscured(str) {
    return (str || '').toLowerCase().includes('x');
  }
  styles = styles;
}
